import axios, { endpoints } from 'src/utils/axios';

import { setSession } from './utils';

export type SignInParams = {
  username: string;
  password: string;
};

export const signInWithPassword = async ({ username, password }: SignInParams): Promise<void> => {
  try {
    const params = { username, password };

    const res = await axios.post(endpoints.auth.signIn, params);
    const { token } = res.data;
    if (!token) {
      throw new Error('Access token not found in response');
    }

    setSession(token);
  } catch (error) {
    console.error('Error during sign in:', error);
    throw error;
  }
};
export const signOut = async (): Promise<void> => {
  try {
    await axios.get(endpoints.auth.logOut);
    await setSession(null);
  } catch (error) {
    console.error('Error during sign out:', error.message);
    throw error;
  }
};
